// Binary-string base64 decoder for binary payloads (PDF, PNG bytes for Blob construction).
const decodeBase64 = (value: string): string | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    return window.atob(value);
  } catch {
    return null;
  }
};

// UTF-8-safe variant for text content (markdown, CSV, JSON) so multi-byte UTF-8
// sequences don't render as mojibake. Pairs with `encodeBase64`'s TextEncoder path.
export const decodeBase64Utf8 = (value: string): string | null => {
  const binary = decodeBase64(value);
  if (binary === null) return null;
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return new TextDecoder('utf-8').decode(bytes);
};

export default decodeBase64;
